import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IAccelerationTaskInfo } from '../models/IAccelerationTaskInfo';
import { Module } from '../Module';
import { GetAccelerationTasksRequest } from '../ServerApi/requests/GetAccelerationTasksRequest';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class AccelerationTasks extends Resource<IAccelerationTaskInfo> {
  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetAccelerationTasksRequest,
      ServerApiMapper.accelerationTasks));
  }
}

Module.instance().service('AccelerationTasks', AccelerationTasks);
